import React, { useState } from "react";
import "./Footer.css";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Send via WhatsApp
  const sendWhatsApp = () => {
    const phoneNumber = "919791506689"; // ✅ remove + here, wa.me requires only digits
    const text = `Hello, my name is ${formData.name}.
My email: ${formData.email} 
Message: ${formData.message}`;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      text
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Our Mission */}
        <div className="footer-section">
          <h3>Our Mission</h3>
          <p>
            Our mission is to deliver the best quality products to buyers so
            that every common man can afford them.
          </p>
        </div>

        {/* Call Us */}
        <div className="footer-section">
          <h3>Call Us</h3>
          <p><span style={{marginRight:'8px'}}>📞</span>+91 90924 06689</p>
          <p><span style={{marginRight:'8px'}}>🌐</span>www.maiyelanexim.com</p>
          <p><span style={{marginRight:'8px'}}>📧</span>maiyelanexports@gmail.com</p>
          <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" 
       fill="currentColor" viewBox="0 0 16 16" >
    <path d="M8 0a5 5 0 0 0-5 5c0 3.866 5 11 5 11s5-7.134 5-11a5 5 0 0 0-5-5zm0 
             7.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" style={{ marginRight: '8px' }}/>
  </svg> No:65, Nettal Garden 2nd Street,</p>
          <p>Perambur, Chennai - 600 011.</p>
        </div>

        {/* Visit Us */}
        {/* <div className="footer-section">
          <h3>Visit Us</h3>
          <p>No:65, Nettal Garden 2nd Street,</p>
          <p>Perambur, Chennai - 600 011.</p>
        </div> */}

        {/* Write Us (Form) */}
        <div className="footer-section">
          <h3>Get in Touch</h3>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className="contact-form"
          >
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              required
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              rows="4"
              required
            ></textarea>

            <div className="contact-buttons">
              <button type="button" onClick={sendWhatsApp}>
                Send via WhatsApp
              </button>
            </div>
          </form>
          {/* Footer Bottom */}
          {/* <div className="footer-bottom">
            <h2>MAIYELAN EXPORTS</h2>
            <p>A Most Excellent Exports</p>
            <div className="social-icons">
              <span>🔗</span>
              <span>💬</span>
              <span>🌐</span>
            </div>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
